import type { ButtonHTMLAttributes } from "react";

// Primary full-width submit button shared by the auth forms (DRY). Shows a
// pending label and disables itself while a request is in flight so a broker
// can't double-submit a login / reset.
interface SubmitButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  pending?: boolean;
  pendingLabel?: string;
  children: React.ReactNode;
}

export function SubmitButton({
  pending = false,
  pendingLabel = "Working…",
  children,
  disabled,
  ...props
}: SubmitButtonProps) {
  return (
    <button
      type="submit"
      disabled={disabled ?? pending}
      className="w-full rounded-md bg-brk-accent px-5 py-3 font-medium text-white transition-colors hover:bg-brk-accent-strong disabled:cursor-not-allowed disabled:opacity-60"
      {...props}
    >
      {pending ? pendingLabel : children}
    </button>
  );
}
